import React from "react";
import Banner from "../Component/home/Banner"
import WhyTrogo from '../Component/home/WhyTrogo';
import PassengerApp from '../Component/home/PassengerApp';
import TransporterAppSection from '../Component/home/TransporterAppSection';
import VehicleCategories from '../Component/home/VehicleCategories';
import TrustSafetySection from '../Component/home/TrustSafetySection';
import CallToAction from '../Component/home/CallToAction';
import SEO from "../Component/SEO";

export default function Home() {
  return (
    <>
    <SEO
  title="TROGO | Smart Transport & Logistics Platform"
  description="Book passenger rides, goods transport, heavy vehicles and emergency services with verified drivers and secure payments."
  keywords="transport booking, logistics platform, goods transport, heavy vehicles, ride booking app"
  url="https://www.togoodsdraft.com/"
/>

      <Banner/>
      <WhyTrogo/>
      <PassengerApp/>
      <TransporterAppSection/>
      <VehicleCategories/>
      <TrustSafetySection/>
      <CallToAction/>
    </>
  );
}
